import styled from "styled-components";

export const NestedContainer = styled.div`
  margin-left: 1.25rem;
`;
